module.exports = __webpack_public_path__ + "static/media/group.7cc4e920.png";